import { render, staticRenderFns } from "./SquareManageView.vue?vue&type=template&id=2913d55d&scoped=true"
import script from "./SquareManageView.vue?vue&type=script&lang=js"
export * from "./SquareManageView.vue?vue&type=script&lang=js"
import style0 from "./SquareManageView.vue?vue&type=style&index=0&id=2913d55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913d55d",
  null
  
)

export default component.exports